import type {ComponentType} from 'react';

import type {
  Conversation,
  ConversationLogItemMessageAdded,
} from '@stripe-internal/conversations-client';
import type {
  MessageComponentProps,
  MessageComponentRegistry,
} from '@stripe-internal/conversations-ui';

import {DotComMessageComponents} from './DotComMessageComponents';

type Props = {
  conversation: Conversation;
  item: ConversationLogItemMessageAdded;
  animated?: boolean;
  disableInteraction?: boolean;
};

export function rowForMessage({
  conversation,
  item,
  animated,
  disableInteraction,
}: Props) {
  const {message} = item;
  const MessageComponent = (
    DotComMessageComponents as MessageComponentRegistry
  )[message.type];

  if (!MessageComponent) {
    return null;
  }

  // TypeScript cannot narrow a dynamic registry component from the message
  // type. The registry fixes the matching controller for every supported key.
  const Component = MessageComponent as ComponentType<MessageComponentProps>;

  return (
    <Component
      key={`${message.type}-row-${item.id}`}
      conversation={conversation}
      message={message}
      animated={animated}
      disableInteraction={disableInteraction}
    />
  );
}
